import { useState } from "react";
import { useNavigate } from "react-router";

import styles from "../../../styles/beneficios/BenefitList.module.scss";
import { ForEach } from "../../components/control-statements/ForEach";

import { StandaloneCouponsAPI } from "../../../providers/StandaloneCouponsAPI";

import { Drawer } from "../../components/Drawer";

import { Icon } from "../../components/core/Icon";
import ChangeBenefitFolderDrawer from "../../containers/beneficios/folders/ChangeBenefitFolderDrawer";
import ContemplateCustomers from "../../containers/beneficios/steps/ContemplateCustomers";
import { BenefitCard } from "./BenefitCard";
import { BenefitInfo } from "./BenefitInfo";
import { BenefitQrCode } from "./BenefitQrCode";

const steps = {
  OPTIONS: "OPTIONS",
  MOVE_BENEFIT: "MOVE_BENEFIT",
  CONTEMPLATE_CUSTOMERS: "CONTEMPLATE_CUSTOMERS",
};

export const BenefitList = ({ benefits, onLoadBenefits, onEditBenefit }) => {
  const [step, setStep] = useState(steps.OPTIONS);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [openQrCode, setOpenQrCode] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);

  const navigate = useNavigate();

  const archiveBenefit = async (benefit) => {
    const confirmed = await window.confirm({
      text: "Você tem certeza que deseja arquivar este cupom? Esta ação não poderá ser desfeita.",
      confirmText: "Arquivar cupom",
      cancelText: "Cancelar",
    });

    if (!confirmed) {
      return false;
    }

    if (!selectedBenefit?.id && !benefit?.id) return false;

    const response = await StandaloneCouponsAPI.putStandaloneCouponStatus(
      selectedBenefit?.id || benefit?.id,
      "ARCHIVED",
    );

    const errors = response.getErrors([]);

    if (errors.length > 0) alert({ text: errors[0] });
    else alert({ text: "Benefício arquivado com sucesso" });

    onLoadBenefits();
    setOpenOptions(false);
  };

  const redirectToChildrens = (benefit) => {
    return navigate(`/beneficios/detalhes/${benefit.id}/vinculos`);
  };

  return (
    <div className={styles["benefits-list"]}>
      <ForEach
        items={benefits}
        render={(item) => {
          return (
            <div className={styles["benefit-card"]}>
              <BenefitCard
                benefit={item}
                onOpenQrCode={(e) => {
                  setOpenQrCode(true);
                  setSelectedBenefit(e);
                }}
                onOpenDetails={(e) => {
                  setOpenDetails(true);
                  setSelectedBenefit(e);
                }}
                onOpenOptions={(e) => {
                  setOpenOptions(true);
                  setSelectedBenefit(e);
                }}
                onEditBenefit={() => onEditBenefit(item)}
                onMoveBenefit={(b) => {
                  setSelectedBenefit(b);
                  setStep(steps.MOVE_BENEFIT);
                }}
                onArchiveBenefit={(b) => {
                  setSelectedBenefit(b);
                  archiveBenefit(b);
                }}
                onRedirectToChildrens={(b) => redirectToChildrens(b)}
                onFollowClients={(b) => {
                  setSelectedBenefit(b);
                  setStep(steps.CONTEMPLATE_CUSTOMERS);
                }}
              />
            </div>
          );
        }}
      />
      <BenefitQrCode
        benefit={selectedBenefit}
        visible={openQrCode}
        onClose={() => setOpenQrCode(false)}
      />

      <Drawer
        visible={openDetails}
        title="Informações do benefício"
        onClose={() => setOpenDetails(false)}
      >
        <BenefitInfo benefit={selectedBenefit} />
      </Drawer>

      <Drawer
        title="Opções"
        visible={openOptions}
        onClose={() => {
          setOpenOptions(false);
          setStep(steps.OPTIONS);
        }}
        showBackButton={step === steps.MOVE_BENEFIT}
        backButton={() => setStep(steps.OPTIONS)}
      >
        {step === steps.OPTIONS ? (
          <>
            <div className={styles.options}>
              <div
                className={styles.option}
                onClick={() => setStep(steps.MOVE_BENEFIT)}
              >
                <Icon name="turn-down-left" size="lg" light />
                <p>Mover benefício</p>
              </div>
              <div className={styles.option} onClick={archiveBenefit}>
                <Icon name="box-archive" size="lg" light />
                <p>Arquivar benefício</p>
              </div>

              {selectedBenefit?.template ? (
                <>
                  <div
                    className={styles.option}
                    onClick={() => redirectToChildrens(selectedBenefit)}
                  >
                    <Icon name="gift" size="lg" light />
                    <p>Visualizar cupons</p>
                  </div>
                </>
              ) : (
                <div
                  className={styles.option}
                  onClick={() => setStep(steps.CONTEMPLATE_CUSTOMERS)}
                >
                  <Icon name="gift" size="lg" light />
                  <p>Contemplar clientes</p>
                </div>
              )}
            </div>
          </>
        ) : null}
      </Drawer>

      <ChangeBenefitFolderDrawer
        visible={step === steps.MOVE_BENEFIT}
        backButton={() => setStep(steps.OPTIONS)}
        onLoadBenefits={() => {
          onLoadBenefits();
          setOpenOptions(false);
          setStep(steps.OPTIONS);
        }}
        onClose={() => setStep(steps.OPTIONS)}
        benefit={selectedBenefit}
      />

      <Drawer
        visible={step === steps.CONTEMPLATE_CUSTOMERS}
        backButton={() => setStep(steps.OPTIONS)}
        showBackButton
        onClose={() => setStep(steps.OPTIONS)}
        title="Contemplar cliente"
      >
        <ContemplateCustomers
          couponId={selectedBenefit?.id}
          onClose={() => setStep(steps.OPTIONS)}
          onFinishContemplation={() => {}}
        />
      </Drawer>
    </div>
  );
};
